import useApiHook from '../../../../hooks/api/useApiHook';
import { useCallback } from 'react';

export const useGetTransaction = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getTransaction = useCallback(async (id) => {
    const url = `/purchases/${id}`;
    await get(url);
  }, [get]);

  return { getTransaction, data, error, loading };
};

export const usePutTransaction = () => {
  const { put, data, error, loading } = useApiHook(true);

  const putTransaction = useCallback(async (id, body) => {
    const url = `/purchases/${id}`;
    await put(url, body);
  }, [put]);

  return { putTransaction, data, error, loading };
};

export const usePostTransaction = () => {
  const { post, data, error, loading } = useApiHook(true);

  const postTransaction = useCallback(async (body) => {
    const url = `/purchases`;
    await post(url, body);
  }, [post]);

  return { postTransaction, data, error, loading };
};

export const useDeleteTransaction = () => {
  const { deleted, data, error, loading } = useApiHook(true);
  const deleteTransaction = useCallback(async (id) => {
    const url = `/purchases/${id}`;
    await deleted(url);
  }, [deleted]);

  return { deleteTransaction, data, error, loading };
};
